module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "planner"
  }, [_c('div', {
    staticClass: "planner__periods-wrapper"
  }, _vm._l((_vm.periods), function(period, periodIndex) {
    return (period.start) ? _c('div', {
      staticClass: "planner__period",
      class: {
        'is-selected': periodIndex === _vm.selectedPeriod, 'is-enabled': period.enabled, 'is-disabled': !period.enabled, 'is-finalized': _vm.isFinalized(period)
      },
      style: (_vm.styleForPeriod(period)),
      attrs: {
        "data-period-index": periodIndex
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickedPeriod($event, period)
        }
      }
    }, [_c('div', {
      staticClass: "planner__period-header",
      class: {
        'is-disabled': !period.enabled
      },
      attrs: {
        "title": _vm.displayPeriodTitle(period)
      }
    }, [_c('span', {
      staticClass: "planner__period-title"
    }, [_vm._v(_vm._s(period.title))])]), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.canEnable(period)),
        expression: "canEnable(period)"
      }],
      staticClass: "planner__enabler",
      class: {
        'is-disabled': !period.enabled
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.togglePeriodEnabled(period)
        }
      }
    }, [_vm._v(_vm._s(period.enabled ? 'disable' : 'enable'))]), _vm._l((period.blocks), function(block, blockIndex) {
      return _c('div', {
        staticClass: "planner__block",
        class: {
          'is-disabled': !period.enabled, 'is-finalized': _vm.isBlockFinalized(period, block)
        },
        style: (_vm.styleForBlock(block)),
        attrs: {
          "data-period-index": periodIndex,
          "data-block-index": blockIndex,
          "title": _vm.displayBlockTitle(period, block)
        }
      }, [_c('div', {
        staticClass: "planner__extend-handle"
      }, [_vm._v(" + - ")])])
    })], 2) : _vm._e()
  })), _c('div', {
    staticClass: "planner__calendar"
  }, [_c('div', {
    staticClass: "planner__header"
  }, [_c('div', {
    staticClass: "planner__week-relative-number"
  }, [_vm._v(" ")]), _vm._l((_vm.displayedDaysInWeek), function(day) {
    return _c('div', {
      staticClass: "planner__day planner__day--heading"
    }, [_vm._v(_vm._s(day))])
  })], 2), _vm._l((_vm.displayedWeeks), function(wk) {
    return _c('div', {
      staticClass: "planner__week",
      class: wk.cls
    }, [_c('div', {
      staticClass: "planner__week-relative-number"
    }, [_vm._v(_vm._s(wk.relativeNumber))]), _c('div', {
      staticClass: "planner__week-days-wrapper",
      attrs: {
        "title": wk.label
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickedWeek($event, wk)
        }
      }
    }, _vm._l((wk.days), function(day) {
      return _c('div', {
        staticClass: "planner__day",
        class: day
      })
    })), _c('div', {
      staticClass: "planner__week-number"
    }, [_vm._v(_vm._s(wk.number))]), _c('div', {
      staticClass: "planner__week-date"
    }, [_vm._v(_vm._s(wk.dates))])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae8b4de8","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/groups/settings/WeekPlanner.vue
// module id = gvNC
// module chunks = 0 1